

















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { DeleteBindGoodds, VideoCreate, VideoEdit, VideoQueryGoodsList } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander, VQuery, TableOperation } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { PriceFormat } from '@/utils/tyepconvert'
import AddBindGoodsDialog from './AddBindGoodsDialog.vue'

@Component({
  components: {
    VTable,
    VQuery,
    VImageUpload,
    AddBindGoodsDialog,
  },
})
export default class EditVideoDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    this.show = false
  }
  private data: any = {}
  private show = false

  private tableData = []
  private queryParam = {}
  private queryModels = []

  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '绑定商品', type: 'primary', click: this.openAddBindGoodsDialog },
  ]

  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '店铺名称', param: 'shopName' },
    { title: '商品名称', param: 'goodsName' },
    { title: '销售金额', param: 'salesIntegral', formatter: PriceFormat },
    {
      title: '操作',
      operation: [
        { title: '删除', click: this.delete },
      ],
    },
  ]

  private async loadData(){
    console.log('loadData')
    const result = await VideoQueryGoodsList({videoId: this.data.id})
    this.tableData = result.goodsList
  }
  
  private openAddBindGoodsDialog(){
    const d = this.$refs.AddBindGoodsDialog as AddBindGoodsDialog
    d.open(this.data)
  }

  public async open(data: any) {
    this.show = true
    this.data = data
    // 加载绑定商品
    this.loadData()
  }

  private async delete(goods: any){
     const param = {
      videoId: this.data.id,
      goodsId: goods.id
    }
    await DeleteBindGoodds(param);
    this.loadData()
  }

}
